import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { HiOutlineDocumentText, HiOutlineTrash, HiPlus,HiX } from "react-icons/hi";
import axios from "../../utils/axios";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";

const RoomRate = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [rateList, setRateList] = useState([]);
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editingRate, setEditingRate] = useState(null);

  const [newRate, setNewRate] = useState({
    TARIF_ID: "",
    RATE_ID: "",
    RATE_CODE: "",
    NAME_RATE: "",
    RATE_DESC: "",
    RATE_STATUS: "1",
  });

  const getDetailProperty = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hotel_id}`);
      if (response.status === 200) {
        setPropData(response.data);
      } else {
        throw new Error("Failed to fetch property details.");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getRateList = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/rooms/rate/${hotel_id}`);
      if (response.status === 200) {
        setRateList(response.data.data);
        
      } else {
        throw new Error("Failed to fetch rate list.");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddRate = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        HOTEL_ID: hotel_id,
        ...newRate, // Spread newRate fields
      };
      const response = await axios.post(`/api/insert/room/rate`, payload);
      if (response.status === 201) {
        toast.success("Rate added successfully!");
        getRateList(hotel_id); // Refresh rate list
        setNewRate({ // Reset form state
          TARIF_ID: "",
          RATE_ID: "",
          NAME_RATE: "",
          RATE_DESC: "",
          RATE_STATUS: "1",
        });
        setAddModalOpen(false); // Close modal
      } else {
        toast.error("Unexpected response from the server.");
      }
    } catch (err) {
      console.error("Error adding rate:", err);
  
      // Display server error message if available
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(`Failed to add rate: ${err.response.data.message}`);
      } else {
        toast.error("Failed to add rate. Please try again.");
      }
    }
  };
  
  const handleEditRate = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ID_TYPE: editingRate.ID_TYPE, // ID of the rate being edited
        HOTEL_ID: hotel_id, // Current hotel ID
        ...editingRate, // Spread the updated fields
      };
      const response = await axios.post(`/api/update/room/rate`, payload);
      if (response.status === 200) {
        toast.success("Rate updated successfully!");
        getRateList(hotel_id); // Refresh the rate list
        setEditModalOpen(false); // Close the modal
      } else {
        toast.error("Unexpected response from the server.");
      }
    } catch (err) {
      console.error("Error updating rate:", err);
      // Display server error message if available
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(`Failed to update rate: ${err.response.data.message}`);
      } else {
        toast.error("Failed to update rate. Please try again.");
      }
    }
  };
  
  const handleDeleteRate = async (rateId) => {
    if (window.confirm("Are you sure you want to delete this rate?")) {
      try {
        const response = await axios.post(`/api/delete/room/rate`, { ID_TYPE: rateId });
        if (response.status === 200) {
          toast.success("Rate deleted successfully.");
          getRateList(hotel_id);
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to delete rate.");
      }
    }
  };

  const openModalEditRate = async (rate) => {
    console.log(rate);
    setEditingRate(rate);
    setEditModalOpen(true);
  }

  const columns = [
    {
      name: "Tarif ID",
      selector: (row) => row.TARIF_ID,
      sortable: true,
    },
    {
      name: "Rate ID",
      selector: (row) => row.RATE_ID,
      sortable: true,
    },
    {
      name: "Rate Code",
      selector: (row) => row.RATE_CODE,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.NAME_RATE,
      sortable: true,
      wrap: true,
    },
    {
      name: "Description",
      selector: (row) => row.RATE_DESC || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => (row.RATE_STATUS === 1 ? "Active" : "Inactive"),
      sortable: true,
    },
    {
      name: "Actionsasdas",
      cell: (row) => (
        <div className="flex items-center space-x-4">
          <button
            className="text-blue-500 hover:text-blue-700"
            onClick={() => {
             
              openModalEditRate(row)
            }}
            title="Edit Rate"
          >
            <HiOutlineDocumentText size={20} />
          </button>
          <button
            className="text-red-500 hover:text-red-700"
            onClick={() => handleDeleteRate(row.ID_TYPE)}
            title="Delete Rate"
          >
            <HiOutlineTrash size={20} />
          </button>
        </div>
      ),
    },
  ];

  const customStyles = {
    table: { style: { border: "1px solid #ddd" } },
    rows: { style: { borderBottom: "1px solid #ddd", padding: "12px" } },
    headCells: { style: { backgroundColor: "#f4f4f4", fontWeight: "bold", borderBottom: "1px solid #ddd" } },
    cells: { style: { wordWrap: "break-word", whiteSpace: "normal" } },
    pagination: { style: { borderTop: "1px solid #ddd", paddingTop: "10px" } },
  };

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      getRateList(userHID);
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, []);

  return (
    <div className="flex h-screen bg-gray-200">
     <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={propData.ID_HOTEL || "Loading..."}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} />

        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          <div className="mb-4 text-sm text-[#101827]">
            <span>Room Rate</span> &gt;{" "}<span>{propData.NAME_HOTEL}</span>
          </div>
          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
            <DataTable
              columns={columns}
              data={rateList}
              pagination
              customStyles={customStyles}
              progressPending={isLoading}
              highlightOnHover
            />
          </section>
        </main>
      </div>

      <button className="fixed bottom-10 right-10 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-500 transition" onClick={() => setAddModalOpen(true)} title="Add Rate">
        <HiPlus size={24} />
      </button>
      {/* Add and Edit Modals */}

      {isAddModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
            
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-sm font-semibold">New Rate {propData.NAME_HOTEL} </h4>
              <HiX 
                size={24} 
                onClick={() => setAddModalOpen(false)} 
                className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
              />
            </div>
            <form onSubmit={handleAddRate}>
              {/* TARIF_ID */}
              <div className="mb-4">
                <label htmlFor="tarif_id" className="block text-xs font-medium mb-1">
                  Tarif ID
                </label>
                <input
                  type="text"
                  id="tarif_id"
                  value={newRate.TARIF_ID}
                  onChange={(e) => setNewRate({ ...newRate, TARIF_ID: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* RATE_ID */}
              <div className="mb-4">
                <label htmlFor="rate_id" className="block text-xs font-medium mb-1">
                  Rate ID
                </label>
                <input
                  type="text"
                  id="rate_id"
                  value={newRate.RATE_ID}
                  onChange={(e) => setNewRate({ ...newRate, RATE_ID: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* RATE_CODE */}
              <div className="mb-4">
                <label htmlFor="rate_code" className="block text-xs font-medium mb-1">
                  Rate Code
                </label>
                <input
                  type="text"
                  id="rate_code"
                  value={newRate.RATE_CODE}
                  onChange={(e) => setNewRate({ ...newRate, RATE_CODE: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* NAME_RATE */}
              <div className="mb-4">
                <label htmlFor="name_rate" className="block text-xs font-medium mb-1">
                  Rate Name
                </label>
                <input
                  type="text"
                  id="name_rate"
                  value={newRate.NAME_RATE}
                  onChange={(e) => setNewRate({ ...newRate, NAME_RATE: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* RATE_DESC */}
              <div className="mb-4">
                <label htmlFor="rate_desc" className="block text-xs font-medium mb-1">
                  Rate Description
                </label>
                <textarea
                  id="rate_desc"
                  value={newRate.RATE_DESC}
                  onChange={(e) => setNewRate({ ...newRate, RATE_DESC: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  rows="3"
                />
              </div>
              {/* RATE_STATUS */}
              <div className="mb-4">
                <label htmlFor="rate_status" className="block text-xs font-medium mb-1">
                  Status
                </label>
                <select
                  id="rate_status"
                  value={newRate.RATE_STATUS}
                  onChange={(e) => setNewRate({ ...newRate, RATE_STATUS: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                >
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                </select>
              </div>
              {/* Buttons */}
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setAddModalOpen(false)}
                  className="bg-gray-300 px-4 py-2 rounded mr-2 text-xs"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded text-xs text-white"
                >
                  Register Rate
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {isEditModalOpen && editingRate && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-sm font-semibold">Edit Rate  </h4>
              <HiX 
                size={24} 
                onClick={() => setEditModalOpen(false)} 
                className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
              />
            </div>
            <form onSubmit={handleEditRate}>
              {/* TARIF_ID */}
              <div className="mb-4">
                <label htmlFor="tarif_id" className="block text-xs font-medium mb-1">
                  Tarif ID
                </label>
                <input
                  type="text"
                  id="tarif_id"
                  value={editingRate.TARIF_ID}
                  onChange={(e) =>
                    setEditingRate({ ...editingRate, TARIF_ID: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* RATE_ID */}
              <div className="mb-4">
                <label htmlFor="rate_id" className="block text-xs font-medium mb-1">
                  Rate ID
                </label>
                <input
                  type="text"
                  id="rate_id"
                  value={editingRate.RATE_ID}
                  onChange={(e) =>
                    setEditingRate({ ...editingRate, RATE_ID: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* RATE_CODE */}
              <div className="mb-4">
                <label htmlFor="rate_code" className="block text-xs font-medium mb-1">
                  Rate Code
                </label>
                <input
                  type="text"
                  id="rate_code"
                  value={editingRate.RATE_CODE}
                  onChange={(e) =>
                    setEditingRate({ ...editingRate, RATE_CODE: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* NAME_RATE */}
              <div className="mb-4">
                <label htmlFor="name_rate" className="block text-xs font-medium mb-1">
                  Rate Name
                </label>
                <input
                  type="text"
                  id="name_rate"
                  value={editingRate.NAME_RATE}
                  onChange={(e) =>
                    setEditingRate({ ...editingRate, NAME_RATE: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* RATE_DESC */}
              <div className="mb-4">
                <label htmlFor="rate_desc" className="block text-xs font-medium mb-1">
                  Rate Description
                </label>
                <textarea
                  id="rate_desc"
                  value={editingRate.RATE_DESC}
                  onChange={(e) =>
                    setEditingRate({ ...editingRate, RATE_DESC: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  rows="3"
                />
              </div>
              {/* RATE_STATUS */}
              <div className="mb-4">
                <label htmlFor="rate_status" className="block text-xs font-medium mb-1">
                  Status
                </label>
                <select
                  id="rate_status"
                  value={editingRate.RATE_STATUS}
                  onChange={(e) =>
                    setEditingRate({ ...editingRate, RATE_STATUS: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                >
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                </select>
              </div>
              {/* Buttons */}
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setEditModalOpen(false)}
                  className="bg-gray-300 px-4 py-2 rounded mr-2 text-xs"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded text-xs text-white"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}


    </div>
  );
};

export default RoomRate;
